import React from "react";
import Radioz from "../atoms/Radioz";

const RadioGroup = ({ options, onChange, value, name, selectedMode }) => {
  const handleRadioChange = (newValue) => {
    onChange && onChange({ name: name, value: newValue });
  };

  return (
    <div className="radio-group">
      {options.map((option) => (
        <Radioz
          key={option.value}
          value={option.value}
          label={option.label}
          icon={option.icon}
          checked={value === option.value}
          onChange={handleRadioChange}
          className={
            value === option.value
              ? `${selectedMode}-box`
              : `${selectedMode}-box-hover`
          }
        />
      ))}
    </div>
  );
};

export default RadioGroup;
